// Libraries
window.jQuery = window.jquery = window.$ = require('jquery');
window.bootstrap = require('bootstrap-sass');
window.DataTable = window.datatable = require('datatables.net-bs');
window.datepicker = require('bootstrap-datepicker');
window.moment = require('moment');
window.timepicker = require('timepicker');
window.fullCalendar = require('fullcalendar');
import * as Vue from 'vue';
window.vue = Vue;
//window.vue = require('vue');
window.axios = require('axios');


// js extracted from old app.js
require('./state_manager.js');
require('./communications_modals.js');
require('./appointment_modals.js');
//require('../../../public/bower_components/sirs-skipTrigger/skipTrigger.jquery.js');
//require('../../../public/bower_components/mutually-exclusive/mutually-exclusive.jquery.js');

// initialize Vue app
//if(document.getElementById('home-content')){
  // var homeVue = new vue({
  //   el: '#home-content',
  //   components: {
  //     'tab-group': TabGroup,
  //     'v-tab': Tab,
  //   },
  //   data: {
  //     test: 'monkeys'
  //   }
  // })
//}


import computerid from './components/ComputerId.vue';

if (document.getElementById('app-navbar-collapse')) {
  var app =  Vue.createApp({

  });
  


    app.component('computerid', computerid);
    app.mount("#computer-id-li");
}

// Initialize jquery plugins
$(document).ready(function(){
    //$('[data-skiptarget]').skipTrigger();

    // shim to force active styling on bootstrap radio/checkbox button groups.
    $('.btn-group .btn input[type=radio],input[type=checkbox]').on('change', function(){
        if ($(this).prop('checked')) {
          $(this).parents('label').addClass('active');
        }else{
          $(this).parents('label').removeClass('active');
        }
    });

    $('.sirs_datepicker').datepicker({
        format: "mm/dd/yyyy"
    }).focus(function() {
        $(this).prop("autocomplete", "off");
        //              return false;
    });

    $('.sirs_datepicker_alt').datepicker({
        format: "mm/dd/yyyy"
    }).focus(function() {
        $(this).prop("autocomplete", "off");
        //              return false;
    });

    $('.sirs_timepicker').timepicker({
        minTime: '5:00am',
        maxTime: '7:00pm'
    }).on('keydown', function(evt){
      if([13,38,40].indexOf(evt.keyCode) < 0) {
        $(this).timepicker('hide');
      }
    }).on('changeTime', function(){
      $(this).removeClass('input-error');
    }).on('timeFormatError', function(){
      $(this).addClass('input-error');
    }).focus(function() {
        $(this).prop("autocomplete", "off");
        //              return false;
    });

});